import React, { useRef } from 'react';
import { Container } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { motion, useScroll, useTransform } from 'framer-motion';
import './HomeCTA.css';

const HomeCTA = () => {
  const navigate = useNavigate();
  const sectionRef = useRef(null);

  // Scroll-linked animation logic
  const { scrollYProgress } = useScroll({
    target: sectionRef,
    offset: ["start end", "center center"] // Starts small at viewport bottom, full size at center
  });

  const scale = useTransform(scrollYProgress, [0, 1], [0.6, 1]);

  return (
    <section className="home-cta-section" ref={sectionRef}>
      <Container>
        <motion.div 
          className="cta-card"
          style={{ 
            scale
          }}
        >
          <div className="cta-bg-image">
            <img 
              src="https://dazbog.ascentbw.com/Images/Home/CTA.png" 
              alt="Solar Field" 
            />
            <div className="cta-overlay"></div>
          </div>
          
          <div className="cta-content1">
            <h2 className="cta-heading1">
              Let’s build your next <br /> renewable energy project.
            </h2>
            <p className="cta-description">
              From planning and financing to execution support, we help <br className="d-none d-md-block" /> 
              turn renewable energy ideas into real projects.
            </p>
            
            <div className="cta-btn-wrapper">
               <button 
                 className="cta-btn-white"
                 onClick={() => navigate('/contact')}
               >
                 Lean More
               </button>
            </div>
          </div>
        </motion.div>
      </Container>
    </section>
  );
};

export default HomeCTA;
